import {
  Component,
  OnInit,
  OnDestroy
} from "@angular/core";
import { NavigationMenuService, LoggingService, LoaderService } from "src/app/services";
import { Subscription } from "rxjs";

@Component({
    selector: 'medpt-privacy-policy',
    templateUrl: './privacy-policy.component.html',
    styleUrls: ['./privacy-policy.component.scss'],
    standalone: false
})
export class PrivacyPolicyComponent implements OnInit {

  linkContent: string = '<div class="sm-loading text-center"></div>';
  constructor(
    private navigationMenuService: NavigationMenuService,
    private loaderService: LoaderService) {
    this.navigationMenuService.getPrivacy().then((data) => {
      this.linkContent = data;
    }).finally(() => {
      this.loaderService.hideLoader();
    });
  }

  ngOnInit(): void { }

}
